import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  consultarDenuncia(){
    window.open("https://oticsofofa.buk.cl/cul_partner_complaint/accesses");
  }

  ingresarDenuncia(){
    window.open("https://oticsofofa.buk.cl/cul_partner_complaint/tickets/new");
  }

}
